import { TableData } from '@framework/ui';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { useAsyncServiceTableColumns } from '../async-select/components/table/useAsyncServiceTableColumns';
import { IAsyncTableWidget } from './IAsyncTableWidget';

export interface IAsyncTableWidgetPreviewProps
  extends IWidgetComponentProps<IAsyncTableWidget> {}

export function AsyncTableWidgetPreview(props: IAsyncTableWidgetPreviewProps) {
  const { widget } = props;

  const columns = useAsyncServiceTableColumns(widget);

  return (
    <TableData
      columns={columns}
      // Fake data per mostrare righe vuote
      dataSource={[{}, {}, {}, {}, {}]}
      pagination={false}
    />
  );
}
